module.exports = __webpack_public_path__ + "static/media/slide1bg.8cbca1b0.jpg";